"use strict";

window.Shopify = window.Shopify || {};

function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie || "");
  const cookies = decodedCookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length);
    }
  }
  return "";
}

function deleteCookie(cname) {
  document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;`;
}

function setCookie(cname, cvalue, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${cname}=${encodeURIComponent(cvalue)}; ${expires}; path=/;`;
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

const parser = new DOMParser();
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
};

const subscribers = {};
const root = document.body;

Shopify.bind = function (fn, scope) {
  return function (...args) {
    return fn.apply(scope, args);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  if (!selector || !selector.options) return -1;

  for (let i = 0; i < selector.options.length; i++) {
    const option = selector.options[i];
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }

  return -1;
};

Shopify.addListener = function (target, eventName, callback) {
  if (!target) return;

  if (target.addEventListener) {
    target.addEventListener(eventName, callback, false);
  } else if (target.attachEvent) {
    target.attachEvent(`on${eventName}`, callback);
  }
};

Shopify.postLink = function (path, options = {}) {
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options = {}
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid
  );

  if (!this.countryEl || !this.provinceEl || !this.provinceContainer) {
    return;
  }

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    if (!this.countryEl) return;
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    if (!this.provinceEl) return;
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function () {
    if (!this.countryEl || !this.provinceEl || !this.provinceContainer) return;

    const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
    if (!selectedOption) return;

    const raw = selectedOption.getAttribute("data-provinces");
    let provinces = [];

    try {
      provinces = raw ? JSON.parse(raw) : [];
    } catch (error) {
      provinces = [];
    }

    this.clearOptions(this.provinceEl);

    if (!provinces || provinces.length === 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const provinceOption = document.createElement("option");
        provinceOption.value = provinces[i][0];
        provinceOption.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(provinceOption);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    if (!selector) return;
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    if (!selector || !Array.isArray(values)) return;

    for (let i = 0; i < values.length; i++) {
      const option = document.createElement("option");
      option.value = values[i];
      option.innerHTML = values[i];
      selector.appendChild(option);
    }
  },
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return "0";
    }

    number = (number / 100).toFixed(precision);

    const parts = number.split(".");
    const dollars = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      `$1${thousands}`
    );
    const centsPart = parts[1] ? decimal + parts[1] : "";

    return dollars + centsPart;
  }

  const match = formatString && formatString.match(placeholderRegex);
  if (!match) return formatString || "";

  switch (match[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};

const getScrollBarWidth = (function () {
  return {
    init: function () {
      const scrollDiv = document.createElement("div");
      scrollDiv.style.width = "100px";
      scrollDiv.style.height = "100px";
      scrollDiv.style.overflow = "scroll";
      scrollDiv.style.position = "absolute";
      scrollDiv.style.top = "-9999px";
      document.body.appendChild(scrollDiv);

      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);

      return scrollbarWidth;
    },
  };
})();

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      if (typeof data !== "undefined") {
        callback(data);
      } else {
        callback();
      }
    });
  }
}

function initLazyloadItem() {
  const lazyVideos = document.querySelectorAll("video.lazy-video-item");

  if (!("IntersectionObserver" in window)) {
    lazyVideos.forEach((video) => loadVideoSources(video, "lazy-video-item"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;
          loadVideoSources(video, "lazy-video-item");
          observerInstance.unobserve(video);
        }
      });
    },
    { threshold: 0.1 }
  );

  lazyVideos.forEach((video) => observer.observe(video));
}

function initLazyload() {
  window.addEventListener("scroll", scrollLazyload);

  if (window.pageYOffset > 40) {
    scrollLazyload();
  }
}

function scrollLazyload() {
  document.querySelectorAll("video.lazy-video").forEach((el) => {
    scrollLazyloadItem(el);
  });
}

function scrollLazyloadItem(el) {
  loadVideoSources(el, "lazy-video");
}

function loadVideoSources(video, classToRemove) {
  if (!video) return;

  const poster = video.dataset.poster;
  const src = video.dataset.src;

  if (poster) {
    video.setAttribute("poster", poster);
    video.removeAttribute("data-poster");
  }

  if (src) {
    video.setAttribute("src", src);
    video.removeAttribute("data-src");
  }

  video.querySelectorAll("source").forEach((source) => {
    const sourceSrc = source.dataset.src;
    if (sourceSrc) {
      source.setAttribute("src", sourceSrc);
      source.removeAttribute("data-src");
    }
  });

  video.classList.remove(classToRemove);
  if (typeof video.load === "function") {
    video.load();
  }
}

// Initialize lazy loading
initLazyloadItem();
initLazyload();